import { render, staticRenderFns } from "./SendThroughEmailDetailComponent.vue?vue&type=template&id=0888a8da&scoped=true&"
import script from "./SendThroughEmailDetailComponent.vue?vue&type=script&lang=js&"
export * from "./SendThroughEmailDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./SendThroughEmailDetailComponent.vue?vue&type=style&index=0&id=0888a8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0888a8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VCol,VRow,VTextField,VTextarea})
